"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittedCollection = void 0;
//@ts-nocheck
exports.submittedCollection = [
    {
        artifact_id: 65102,
        type: "SUBMITTED",
        identifier: "16508",
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 78117,
                    procedure_name: null,
                    procedure_code: "71045",
                    type: null,
                    units: 2.0,
                    sequence_number: 1,
                    transaction_id: "CMX-P78111",
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "J90",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 1,
                                type: null,
                                evidence: [],
                                used: true
                            },
                            {
                                diagnosis_code: "R91.8",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 2,
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 65076,
        type: "PREDICTION",
        identifier: "16508",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 78084,
                    procedure_name: null,
                    procedure_code: "71045",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 1.0,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.026786310980224895,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ap chest",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 10,
                                        end: 27,
                                        level: "ngram",
                                        content: "AP PORTABLE CHEST"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.02515449546053527,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ap portabl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 10,
                                        end: 21,
                                        level: "ngram",
                                        content: "AP PORTABLE"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.02515449546053527,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "portabl at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 13,
                                        end: 30,
                                        level: "ngram",
                                        content: "PORTABLE CHEST at"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.02515449546053527,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "portabl at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 13,
                                        end: 30,
                                        level: "ngram",
                                        content: "PORTABLE CHEST at"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.02329906106504054,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ap chest",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 10,
                                        end: 27,
                                        level: "ngram",
                                        content: "AP PORTABLE CHEST"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.020222672864535343,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ap portabl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 10,
                                        end: 21,
                                        level: "ngram",
                                        content: "AP PORTABLE"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.01855331338777858,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "portabl 99/99/9999",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 13,
                                        end: 42,
                                        level: "ngram",
                                        content: "PORTABLE CHEST at  04/16/2021"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.014242066957548096,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ap at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 10,
                                        end: 30,
                                        level: "ngram",
                                        content: "AP PORTABLE CHEST at"
                                    },
                                    {
                                        start: 9,
                                        end: 48,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.011193661917930146,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "pneumothorax",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 317,
                                        end: 329,
                                        level: "ngram",
                                        content: "pneumothorax"
                                    },
                                    {
                                        start: 302,
                                        end: 330,
                                        level: "sentence",
                                        content: "No significant pneumothorax."
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.008958395545959593,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "99/99/9999 clinic",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 32,
                                        end: 58,
                                        level: "ngram",
                                        content: "04/16/2021, 0538\n CLINICAL"
                                    },
                                    {
                                        start: 9,
                                        end: 115,
                                        level: "sentence",
                                        content: " AP PORTABLE CHEST at  04/16/2021, 0538\n CLINICAL INFORMATION: s/p IVC thrombectomy ICU,  interval changes"
                                    }
                                ]
                            },
                            type: "Ngram"
                        }
                    ],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.74,
            primary_code_confidence: 0.78,
            primary_predicted_code: "J90",
            automate: true,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "J90",
                    automate: false,
                    confidence: 0.74,
                    sequence_number: null,
                    type: null,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.08488059676914204,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "small pleural",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 228,
                                        end: 241,
                                        level: "ngram",
                                        content: "small pleural"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Categorical",
                            score: 0.0710882761438588,
                            feature: {
                                category: "Chest",
                                field: "body_region",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Ngram",
                            score: 0.04435898560114349,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "effus",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 242,
                                        end: 251,
                                        level: "ngram",
                                        content: "effusions"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.011073228848399883,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "signific pneumothorax",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 305,
                                        end: 329,
                                        level: "ngram",
                                        content: "significant pneumothorax"
                                    },
                                    {
                                        start: 302,
                                        end: 330,
                                        level: "sentence",
                                        content: "No significant pneumothorax."
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.005334163540646237,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "small effus",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 228,
                                        end: 251,
                                        level: "ngram",
                                        content: "small pleural effusions"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.005334163540646237,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "small effus",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 228,
                                        end: 251,
                                        level: "ngram",
                                        content: "small pleural effusions"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.005334163540646237,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "silhouett effus",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 216,
                                        end: 251,
                                        level: "ngram",
                                        content: "silhouette, small pleural effusions"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        }
                    ],
                    used: true
                },
                {
                    diagnosis_code: "R91.8",
                    automate: false,
                    confidence: 0.74,
                    sequence_number: null,
                    type: null,
                    evidence: [
                        {
                            type: "Categorical",
                            score: 0.17442006243430577,
                            feature: {
                                category: "Chest",
                                field: "body_region",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Categorical",
                            score: 0.01382358440418413,
                            feature: {
                                category: "XRAY",
                                field: "procedure_category",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Categorical",
                            score: 0.01382358440418413,
                            feature: {
                                category: "Digital Radiography",
                                field: "procedure_type",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Ngram",
                            score: 0.013657221043351353,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "consolid",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 286,
                                        end: 299,
                                        level: "ngram",
                                        content: "consolidation"
                                    },
                                    {
                                        start: 191,
                                        end: 302,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.012350799860628557,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "clinic s",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 50,
                                        end: 73,
                                        level: "ngram",
                                        content: "CLINICAL INFORMATION: s"
                                    },
                                    {
                                        start: 49,
                                        end: 115,
                                        level: "sentence",
                                        content: " CLINICAL INFORMATION: s/p IVC thrombectomy ICU,  interval changes"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.012350799860628557,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "basal no",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 280,
                                        end: 304,
                                        level: "ngram",
                                        content: "basal consolidation.  No"
                                    },
                                    {
                                        start: 191,
                                        end: 330,
                                        level: "sentence",
                                        content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  No significant pneumothorax."
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.012350799860628557,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "detail abov",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 390,
                                        end: 404,
                                        level: "ngram",
                                        content: "detailed above"
                                    },
                                    {
                                        start: 331,
                                        end: 407,
                                        level: "sentence",
                                        content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.012350799860628557,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "in detail",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 375,
                                        end: 398,
                                        level: "ngram",
                                        content: "in findings as detailed"
                                    },
                                    {
                                        start: 331,
                                        end: 407,
                                        level: "sentence",
                                        content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.012350799860628557,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "chang detail",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 368,
                                        end: 398,
                                        level: "ngram",
                                        content: "change in findings as detailed"
                                    },
                                    {
                                        start: 331,
                                        end: 407,
                                        level: "sentence",
                                        content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        }
                    ],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 65081,
        type: "ASSEMBLED",
        identifier: "16508",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 78090,
                    procedure_name: null,
                    procedure_code: "71045",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: true,
                    confidence: 1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.74,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "J90",
                                automate: false,
                                confidence: 0.74,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.08488059676914204,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small pleural",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 241,
                                                    level: "ngram",
                                                    content: "small pleural"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.0710882761438588,
                                        feature: {
                                            category: "Chest",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.04435898560114349,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 242,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.011073228848399883,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "signific pneumothorax",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 305,
                                                    end: 329,
                                                    level: "ngram",
                                                    content: "significant pneumothorax"
                                                },
                                                {
                                                    start: 302,
                                                    end: 330,
                                                    level: "sentence",
                                                    content: "No significant pneumothorax."
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "silhouett effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 216,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "silhouette, small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            },
                            {
                                diagnosis_code: "R91.8",
                                automate: false,
                                confidence: 0.74,
                                sequence_number: 2,
                                type: null,
                                evidence: [
                                    {
                                        type: "Categorical",
                                        score: 0.17442006243430577,
                                        feature: {
                                            category: "Chest",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.01382358440418413,
                                        feature: {
                                            category: "XRAY",
                                            field: "procedure_category",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.01382358440418413,
                                        feature: {
                                            category: "Digital Radiography",
                                            field: "procedure_type",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.013657221043351353,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "consolid",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 286,
                                                    end: 299,
                                                    level: "ngram",
                                                    content: "consolidation"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "clinic s",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 50,
                                                    end: 73,
                                                    level: "ngram",
                                                    content: "CLINICAL INFORMATION: s"
                                                },
                                                {
                                                    start: 49,
                                                    end: 115,
                                                    level: "sentence",
                                                    content: " CLINICAL INFORMATION: s/p IVC thrombectomy ICU,  interval changes"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "basal no",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 280,
                                                    end: 304,
                                                    level: "ngram",
                                                    content: "basal consolidation.  No"
                                                },
                                                {
                                                    start: 191,
                                                    end: 330,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  No significant pneumothorax."
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "detail abov",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 390,
                                                    end: 404,
                                                    level: "ngram",
                                                    content: "detailed above"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "in detail",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 375,
                                                    end: 398,
                                                    level: "ngram",
                                                    content: "in findings as detailed"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "chang detail",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 368,
                                                    end: 398,
                                                    level: "ngram",
                                                    content: "change in findings as detailed"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 1.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.74,
            primary_code_confidence: 0.78,
            primary_predicted_code: "J90",
            automate: true,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 65041,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 78051,
                    procedure_name: null,
                    procedure_code: "71045",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 65097,
        type: "PROCESSED",
        identifier: "16508",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 78111,
                    procedure_name: null,
                    procedure_code: "71045",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: true,
                    confidence: 1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.74,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "J90",
                                automate: false,
                                confidence: 0.74,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.08488059676914204,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small pleural",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 241,
                                                    level: "ngram",
                                                    content: "small pleural"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.0710882761438588,
                                        feature: {
                                            category: "Chest",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.04435898560114349,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 242,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.011073228848399883,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "signific pneumothorax",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 305,
                                                    end: 329,
                                                    level: "ngram",
                                                    content: "significant pneumothorax"
                                                },
                                                {
                                                    start: 302,
                                                    end: 330,
                                                    level: "sentence",
                                                    content: "No significant pneumothorax."
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "small effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 228,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.005334163540646237,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "silhouett effus",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 216,
                                                    end: 251,
                                                    level: "ngram",
                                                    content: "silhouette, small pleural effusions"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            },
                            {
                                diagnosis_code: "R91.8",
                                automate: false,
                                confidence: 0.74,
                                sequence_number: 2,
                                type: null,
                                evidence: [
                                    {
                                        type: "Categorical",
                                        score: 0.17442006243430577,
                                        feature: {
                                            category: "Chest",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.01382358440418413,
                                        feature: {
                                            category: "XRAY",
                                            field: "procedure_category",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.01382358440418413,
                                        feature: {
                                            category: "Digital Radiography",
                                            field: "procedure_type",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.013657221043351353,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "consolid",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 286,
                                                    end: 299,
                                                    level: "ngram",
                                                    content: "consolidation"
                                                },
                                                {
                                                    start: 191,
                                                    end: 302,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "clinic s",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 50,
                                                    end: 73,
                                                    level: "ngram",
                                                    content: "CLINICAL INFORMATION: s"
                                                },
                                                {
                                                    start: 49,
                                                    end: 115,
                                                    level: "sentence",
                                                    content: " CLINICAL INFORMATION: s/p IVC thrombectomy ICU,  interval changes"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "basal no",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 280,
                                                    end: 304,
                                                    level: "ngram",
                                                    content: "basal consolidation.  No"
                                                },
                                                {
                                                    start: 191,
                                                    end: 330,
                                                    level: "sentence",
                                                    content: "Stable cardiomediastinal silhouette, small pleural effusions and left greater than right basal consolidation.  No significant pneumothorax."
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "detail abov",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 390,
                                                    end: 404,
                                                    level: "ngram",
                                                    content: "detailed above"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "in detail",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 375,
                                                    end: 398,
                                                    level: "ngram",
                                                    content: "in findings as detailed"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.012350799860628557,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "chang detail",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 368,
                                                    end: 398,
                                                    level: "ngram",
                                                    content: "change in findings as detailed"
                                                },
                                                {
                                                    start: 331,
                                                    end: 407,
                                                    level: "sentence",
                                                    content: " IMPRESSION: No significant interval change in findings as detailed above.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 1.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.74,
            primary_code_confidence: 0.78,
            primary_predicted_code: "J90",
            automate: true,
            type: null,
            evidence: [],
            codes: []
        }
    }
];
//# sourceMappingURL=submitted-collection.fixture.js.map